import {HashRouter, Route, Routes} from "react-router-dom";
import HomePage from "../Pages/HomePage";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import UserProfilePage from "../Pages/UserProfilePage";
import EmployeePage from "../Pages/EmployeePage";
import RevenuePage from "../Pages/RevenuePage";
import GlPage from "../Pages/GlPage";
import SettingPage from "../Pages/SettingPage";
import LoginPage from "../Pages/LoginPage";
import LawPage from "../Pages/LawPage";
import AuditPage from "../Pages/AuditPage";
import ET_Page from "../Pages/ET_Page";
import UnitProfilePage from "../Pages/UnitProfilePage";
import EfdPage from "../Pages/EfdPage";



export default function AppRoute(){

    let state=useSelector((state)=> state);
    const [UserRole, setUserRole] = useState(state);



    const isAdmin = () => state.access === 'admin';
    const isADC = () => state.access === 'ADC';
    const isDivision = () => state.access === 'Division';
    const isCircle = () => state.access === 'Circle';
    const isSection = () => state.access === 'Section';
    const isAP = () => state.access === 'AP';
    const isGL = () => state.access === 'GL';
    const isET = () => state.access === 'ET';
    const isLaw = () => state.access === 'Law';
    const isOther = () => state.access === 'Other';
    const isEfd = () => state.access === 'EFD';



    return(

        <HashRouter >



            <Routes>

                <Route path="/" element={<LoginPage/>}></Route>
                <Route path="/home" element={<HomePage/>}></Route>
                {
                    isAdmin() &&(
                    <>

                        <Route path="/profile" element={<UserProfilePage/>}></Route>
                        <Route path="/gl" element={<GlPage/>}></Route>
                        <Route path="/hr" element={<EmployeePage/>}></Route>
                        <Route path="/setting" element={<SettingPage/>}></Route>
                        <Route path="/law" element={<LawPage/>}></Route>
                        <Route path="/audit" element={<AuditPage/>}></Route>
                        <Route path="/et" element={<ET_Page/>}></Route>
                        <Route path="/up" element={<UnitProfilePage/>}></Route>
                        <Route path="/efd" element={<EfdPage/>}></Route>
                        <Route path="/revenue" element={<RevenuePage/>}></Route>

                    </>
                    )

                }
                { isADC() &&(
                    <>
                        <Route path="/up" element={<UnitProfilePage/>}></Route>
                        <Route path="/gl" element={<GlPage/>}></Route>
                        <Route path="/profile" element={<UserProfilePage/>}></Route>
                        <Route path="/revenue" element={<RevenuePage/>}></Route>
                    </>
                ) }
                { isDivision() &&(
                        <>
                            <Route path="/up" element={<UnitProfilePage/>}></Route>
                            <Route path="/profile" element={<UserProfilePage/>}></Route>
                            <Route path="/revenue" element={<RevenuePage/>}></Route>
                            <Route path="/efd" element={<EfdPage/>}></Route>
                        </>
                    ) }
                { isCircle() &&(
                    <>
                        <Route path="/up" element={<UnitProfilePage/>}></Route>
                        <Route path="/profile" element={<UserProfilePage/>}></Route>
                        <Route path="/revenue" element={<RevenuePage/>}></Route>
                        <Route path="/efd" element={<EfdPage/>}></Route>
                    </>
                ) }
                { isAP() &&(
                    <>
                        <Route path="/hr" element={<EmployeePage/>}></Route>
                        <Route path="/setting" element={<SettingPage/>}></Route>
                        <Route path="/profile" element={<UserProfilePage/>}></Route>
                        <Route path="/revenue" element={<RevenuePage/>}></Route>
                    </>
                ) }
                { isGL() &&(
                    <>
                        <Route path="/gl" element={<GlPage/>}></Route>
                        <Route path="/profile" element={<UserProfilePage/>}></Route>
                    </>
                ) }
                { isET() &&(
                    <>
                        <Route path="/et" element={<ET_Page/>}></Route>
                        <Route path="/profile" element={<UserProfilePage/>}></Route>
                    </>
                ) }
                { isLaw() &&(
                    <>
                        <Route path="/law" element={<LawPage/>}></Route>
                        <Route path="/profile" element={<UserProfilePage/>}></Route>
                    </>
                ) }
                { isEfd() &&(
                    <>
                        <Route path="/efd" element={<EfdPage/>}></Route>

                    </>
                ) }





                <Route path="/*" element={<LoginPage/>}></Route>

            </Routes>
        </HashRouter>


    );
}


